
(function(){
  const ROOT_ATTR = 'data-beck0908-root';
  const PANEL_ATTR = 'data-beck0908-panel';
  const TRIGGER_ATTR = 'data-beck0908-trigger';

  const items = Array.from(document.querySelectorAll('['+ROOT_ATTR+']'));
  if(!items.length) return;

  // 工具：关闭所有
  function closeAll(except){
    items.forEach(it=>{
      if(except && it===except) return;
      it.classList.remove('is-open');
      const trigger = it.querySelector('['+TRIGGER_ATTR+']');
      if(trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  // 点击外部关闭
  document.addEventListener('click', (e)=>{
    const inside = e.target.closest('['+ROOT_ATTR+']');
    if(!inside){ closeAll(); }
  });

  // ESC 关闭
  document.addEventListener('keydown', (e)=>{
    if(e.key === 'Escape'){ closeAll(); }
  });

  // 初始化每个项
  items.forEach(item=>{
    const trigger = item.querySelector('['+TRIGGER_ATTR+']');
    const panel = item.querySelector('['+PANEL_ATTR+']');
    if(!trigger || !panel) return;

    // 点击触发展开/收起（移动端 & 桌面键盘均可）
    trigger.addEventListener('click', (e)=>{
      // 若是桌面且明显需要跳转，按住 Ctrl/Meta 允许新开页
      if(e.metaKey || e.ctrlKey) return;

      e.preventDefault();
      const isOpen = item.classList.contains('is-open');
      closeAll();
      if(!isOpen){
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }else{
        trigger.setAttribute('aria-expanded', 'false');
      }
    });

    // 键盘进入时展开
    trigger.addEventListener('keydown', (e)=>{
      if(e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' '){
        e.preventDefault();
        closeAll();
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        // 把焦点移入面板第一个可聚焦元素
        const focusable = panel.querySelector('a,button,[tabindex]:not([tabindex="-1"])');
        if(focusable) focusable.focus();
      }
    });

    // PC：悬停也展开（小延迟避免抖动）
    let hoverTimer;
    item.addEventListener('mouseenter', ()=>{
      if (window.matchMedia('(min-width:1025px)').matches){
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(()=>{
          closeAll();
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }, 80);
      }
    });
    item.addEventListener('mouseleave', ()=>{
      if (window.matchMedia('(min-width:1025px)').matches){
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(()=>{
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }, 120);
      }
    });
  });
})();



// // 下面是0923产品lookbook
// document.addEventListener('DOMContentLoaded', function() {
//   const layoutButtons = document.querySelectorAll('.beckpdl-layout-btn');  // 获取按钮
//   const class1Content = document.getElementById('class1-content');  // 获取产品类1内容
//   const class2Content = document.getElementById('class2-content');  // 获取产品类2内容

//   // 默认显示产品类1，隐藏产品类2
//   class2Content.style.display = 'none';

//   layoutButtons.forEach(function(button) {
//     button.addEventListener('click', function() {
//       const selectedClass = button.getAttribute('data-class');

//       // 更新按钮的选中状态
//       layoutButtons.forEach(function(btn) {
//         btn.classList.remove('beckpdl-selected');
//       });
//       button.classList.add('beckpdl-selected');

//       // 控制显示和隐藏对应的产品类
//       if (selectedClass === 'class1') {
//         class1Content.style.display = 'flex';
//         class2Content.style.display = 'none';
//       } else if (selectedClass === 'class2') {
//         class1Content.style.display = 'none';
//         class2Content.style.display = 'flex';
//       }
//     });
//   });
// });
